// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wynaut: PokeData = {
  "id": 360,
  "name": "wynaut",
  "height": 6,
  "weight": 140,
  "base_experience": 52,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "counter",
    "amnesia",
    "splash",
    "destiny-bond",
    "charm",
    "safeguard",
    "encore",
    "mirror-coat"
  ],
  "moves": [
    "splash",
    "psychic-fangs",
    "kinesis",
    "psychic-terrain",
    "psy-pulse",
    "zen-headbutt",
    "reflect",
    "future-sight",
    "healing-wish",
    "synchronize",
    "psywave",
    "prismatic-cage",
    "calm-mind"
  ],
  "evolution_chain": {
    "id": 100,
    "item": {
      "name": "lax-incense"
    },
    "species": [
      {
        "name": "wynaut",
        "order": 232,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wobbuffet",
        "order": 233,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 360,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71.5,
    "speed": 23,
    "ability_power": 23
  },
  "stat_changes": [],
  "catch_rate": 125,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
